import type { Action } from '@atlassian/react-sweet-state';
import type { State, HasSeenItKey } from '../../types';
import { performGetHasSeenRequest } from './utils';

export const getHasSeen =
	(hasSeenKey: HasSeenItKey): Action<State> =>
	async ({ getState, setState }) => {
		const currentState = getState();

		const currentStateForHasSeenKey = currentState[hasSeenKey];

		if (
			currentStateForHasSeenKey?.fetchStatus === 'fetched' ||
			currentStateForHasSeenKey?.fetchStatus === 'fetching'
		) {
			return;
		}

		setState({
			[hasSeenKey]: { ...currentStateForHasSeenKey, fetchStatus: 'fetching' },
		});

		const response = await performGetHasSeenRequest(hasSeenKey);

		setState({
			[hasSeenKey]: {
				fetchStatus: 'fetched',
				value: response,
			},
		});
	};
